function reducer (state, action){

  if(action.type === 'SET_DEPARTURE_LOCATIONS'){
    return {...state, departureLocations: action.payload, isLoadingDepartures: false}
  }

  if(action.type === 'SET_DEPARTURE_LOCATION'){
    return {...state, departureLocation: action.payload, isLoadingTripList: true}
  }

  if(action.type === 'SET_TRIP_IS_LOADING_LIST'){
    return {...state, isLoadingTripList: true}
  }

  if(action.type === 'SET_TRIP_LIST'){
    return {...state, tripList: action.payload, isLoadingTripList: false}
  }

  if(action.type === 'SET_TRIP'){
    return {...state, journeySelected: action.payload}
  }

  if(action.type === 'SET_LOADING_RESERVATION'){
    return {...state, isLoadingReservation: true}
  }

  if(action.type === 'SET_BOOKED_TRIP'){
    return {...state, isLoadingReservation: false, booked: action.payload.trip}
  }

  return state
}

export default reducer
